export default __webpack_public_path__ + "static/media/LandbrugFodevare.2498ce9b.svg";